import React from 'react';
import { withRouter } from 'react-router';
import { Modal, Row, Col } from 'react-bootstrap';

const SuccessModal = props => {
  return (
    <Modal className="thank-you-modal" show={props.show}>
      {/*<span className="litpog-remove" onClick={props.toggle} />*/}
      <Modal.Header closeButton>
        <Modal.Title>Thank you!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p className="description-form">
            You have sent {props.firstName} {props.lastName} a year subscription to Presence: Walk with God!
            <br />
            The invitation email will arrive to {props.email} any minute now.
          </p>
        </div>
      </Modal.Body>
      <Row>
        <Col md={6} />
        <Col md={6}>
          <div className="white-submit">
            <button type="button" onClick={() => props.history.push('/')}>
              ok
            </button>
          </div>
        </Col>
      </Row>

      {/*<button onClick={() => props.history.push('/')}>ok</button>*/}

      <Modal.Footer />
    </Modal>
  );
};

export default withRouter(SuccessModal);



// WEBPACK FOOTER //
// ./src/components/Register/SuccessModal.js